import { Accordion as RadixAccordion } from 'radix-ui';
import { ReactNode } from 'react';
import './accordion.css';

const Accordion = ({
    open,
    children,
}: {
    open?: boolean;
    children: ReactNode;
}) => {
    return (
        <RadixAccordion.Root
            type="single"
            className="accordion"
            collapsible
            defaultValue={open ? 'item-1' : undefined}
        >
            <RadixAccordion.Item value="item-1" className="accordion__item">
                {children}
            </RadixAccordion.Item>
        </RadixAccordion.Root>
    );
};

const Header = ({ children }: { children: ReactNode }) => {
    return (
        <RadixAccordion.Header className="accordion__item__header">
            <RadixAccordion.Trigger className="accordion__item__header__trigger">
                {children}
            </RadixAccordion.Trigger>
        </RadixAccordion.Header>
    );
};
Accordion.Header = Header;

const Content = ({ children }: { children: ReactNode }) => {
    return (
        <RadixAccordion.Content className="accordion__item__content">
            {children}
        </RadixAccordion.Content>
    );
};
Accordion.Content = Content;

export default Accordion;
